export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_01.2c1d8a0c.jpg";